/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RelationshipResponseDto { 
    id: string;
    workItemId: string;
    tenantId: string;
    targetId: string;
    targetEntity: string;
    relationshipType: RelationshipResponseDto.RelationshipTypeEnum;
    notes?: string;
    metadata?: any;
    createdOn: string;
    createdBy?: string;
    updatedOn: string;
    updatedBy?: string;
}
export namespace RelationshipResponseDto {
    export type RelationshipTypeEnum = 'relatedTo' | 'blocks' | 'blockedBy' | 'duplicates' | 'partOf' | 'basedOn';
    export const RelationshipTypeEnum = {
        RelatedTo: 'relatedTo' as RelationshipTypeEnum,
        Blocks: 'blocks' as RelationshipTypeEnum,
        BlockedBy: 'blockedBy' as RelationshipTypeEnum,
        Duplicates: 'duplicates' as RelationshipTypeEnum,
        PartOf: 'partOf' as RelationshipTypeEnum,
        BasedOn: 'basedOn' as RelationshipTypeEnum
    };
}


